import { CONTENT_TYPE_IDS } from "../../../constants";
import { formatRichText , filterContentById} from "../../../functions";


export const ParagraphSection = ({ content }) => {
	const paragraphSections = filterContentById(content, CONTENT_TYPE_IDS.PARAGRAPH);
	const formattedParagraphs = paragraphSections?.map(({ fields }) => formatRichText(fields.paragraph)) || [];
	return (
		<div className="flex flex-col md:flex-row items-start justify-center gap-16 my-4 ">
			{formattedParagraphs.map((paragraph, index) => (
				<div
					key={index}
					className="flex flex-col gap-2 text-is2-gray-300 text-lg m-auto px-12 md:p-0 md:m-0 md:w-1/4 text-center"
				>
					{paragraph}
				</div>
			))}
		</div>
	);
};
